export const QUESTION_TYPES = [
  {
    value: 'texto',
    label: 'Texto libre',
    description: 'El encuestado escribe su respuesta (párrafo o frase).',
  },
  {
    value: 'opcion_multiple',
    label: 'Selección múltiple',
    description: 'Elige una o varias opciones de una lista.',
  },
  {
    value: 'checkbox',

    label: 'Selección única',
    description: 'Sólo puede marcar una opción.',
  }, 
  {
    value: 'numero',
    label: 'Número',
    description: 'Respuesta numérica (edad, puntuación, etc.).',
  },
  {
    value: 'booleano',
    label: 'Sí / No',
    description: 'Pregunta binaria (verdadero/falso).',
  },
];
